import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_CUSTOM_LIST_PRODUCT_DATA } from 'mocks/queries';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useClosestStoreZipcode from 'hooks/useClosestStoreZipcode';
import Placeholder from 'components/consumer/Placeholder';
import { colorBrand } from 'styles/layout/colors';
import IconMapMarker from 'components/icons/IconMapMarker';
import avo from 'analytics/avo';
import { storeUrlSlugMapping } from 'commons/ShowroomStaticData';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPShowroomModal from './PDPShowroomModal';
const PDPOnDisplayInShowroomInner = () => {
  const $ = _c(26);
  const [modalOpen, setModalOpen] = useState(false);
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const productId = basicDetails?.id || null;
  const closestStoreLocation = useClosestStoreZipcode();
  const storeUrl = closestStoreLocation?.storeLocation?.url || null;
  const t0 = storeUrlSlugMapping[storeUrl]?.slug;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      slug: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !storeUrlSlugMapping[storeUrl]?.slug;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: showroomDisplayData,
    loading
  } = useSuspenseQuery(GET_CUSTOM_LIST_PRODUCT_DATA, t3);
  const productsOnDisplay = showroomDisplayData?.getCustomListProductData?.products_list?.map(_temp).filter(Boolean) || [];
  const showText = !!productsOnDisplay.length && productsOnDisplay.includes(productId);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setModalOpen(false);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const modalOnClose = t4;
  let t5;
  if ($[6] !== closestStoreLocation?.storeLocation?.name || $[7] !== closestStoreLocation?.storeLocation?.url || $[8] !== modalOpen) {
    t5 = () => {
      if (!modalOpen) {
        avo.ctaClicked({
          text: `On display in ${closestStoreLocation?.storeLocation?.name}`,
          targetUrl: closestStoreLocation?.storeLocation?.url,
          cta: "Retail Store",
          component: "Side Panel",
          location: "PDP"
        });
      }
      setModalOpen(!modalOpen);
    };
    $[6] = closestStoreLocation?.storeLocation?.name;
    $[7] = closestStoreLocation?.storeLocation?.url;
    $[8] = modalOpen;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const toggleModal = t5;
  if (loading) {
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Placeholder type="rect" loading={true} style={{
        height: "20px",
        marginBottom: "30px"
      }} />;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  if (showText) {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <span className="text-xs font-bold text-gray-light2">On display in </span>;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <span><IconMapMarker height={12} width={12} color={colorBrand} /></span>;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    const t8 = closestStoreLocation?.storeLocation?.name;
    let t9;
    if ($[13] !== t8) {
      t9 = <span className="text-xs font-bold text-brand hover:cursor-pointer hover:no-underline flex items-center">{t7}<span className="ml-1">{" "}{t8}</span></span>;
      $[13] = t8;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    let t10;
    if ($[15] !== t9 || $[16] !== toggleModal) {
      t10 = <button className="text-xs font-bold text-brand cursor-pointer bg-transparent border-0 pb-[5px] text-left flex items-center" onClick={toggleModal} type="button" aria-label="Open Showroom">{t6}{t9}</button>;
      $[15] = t9;
      $[16] = toggleModal;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== loading || $[19] !== modalOpen || $[20] !== storeUrl) {
      t11 = !loading && <PDPShowroomModal data={storeUrlSlugMapping[storeUrl]?.showroom} onClose={modalOnClose} isOpen={modalOpen} />;
      $[18] = loading;
      $[19] = modalOpen;
      $[20] = storeUrl;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== t10 || $[23] !== t11) {
      t12 = <div className="text-xs font-bold text-brand cursor-pointer bg-transparent border-0 pb-[5px]">{t10}{t11}</div>;
      $[22] = t10;
      $[23] = t11;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    return t12;
  }
  let t6;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="PDPOnDisplayInShowroom__filler" />;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};
const PDPOnDisplayInShowroom = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPOnDisplayInShowroomInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPOnDisplayInShowroom;
function _temp(item) {
  return item.id;
}